import React, { useState, useEffect } from "react";
const slides = [
  {
    image: "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?auto=format&fit=crop&crop=center&w=1200&h=520&q=80",
    text: "Recommendations to enhance your online therapy experience",
    tag: "Tip of the day",
  },
  {
    image: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?auto=format&fit=crop&crop=center&w=1200&h=520&q=80",
    text: "Discover effective techniques for mental well-being",
    tag: "Wellness",
  },
  {
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&crop=center&w=1200&h=520&q=80",
    text: "Mindfulness practices you can try every day",
    tag: "Mindfulness",
  },
  {
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&crop=center&w=1200&h=520&q=80",
    text: "Build resilience with guided self-care routines",
    tag: "Self-care",
  },
];

const CustomSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-[200px] sm:h-[230px] md:h-[260px] rounded-2xl overflow-hidden shadow-md">
      {/* Arkaplan resim */}
      <img
        src={slides[current].image}
        alt="slider"
        className="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500"
      />
      {/* Koyu gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

      {/* İçerik */}
      <div className="relative z-10 h-full flex flex-col justify-center px-5 sm:px-7 max-w-[65%]">
        <span className="text-[10px] sm:text-xs font-poppins text-purple-300 uppercase tracking-widest mb-1">
          {slides[current].tag}
        </span>
        <p className="font-poppins text-white text-sm sm:text-base leading-snug">
          {slides[current].text}
        </p>
      </div>

      {/* Dot nav */}
      <div className="absolute bottom-3 left-5 flex gap-1.5 z-10">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-[4px] rounded-full transition-all duration-300 ${
              i === current ? "w-6 bg-white" : "w-2 bg-white/40"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomSlider;
